import {UmpirePlayerStats} from '../umpire-player-stats';

export interface UmpireSquadPlayerStats {
  squad_id: string | undefined;

  home_squad: UmpirePlayerStats[];

  away_squad: UmpirePlayerStats[];
}
